import { cx } from "components/Graphs/utils";
import React from "react";

export interface BrandLockupProps {
  logo: React.ReactNode;
  compact?: boolean;
  ariaLabel: string;
  className?: string;
  logoClassName?: string;
}

export const BrandLockup: React.FC<BrandLockupProps> = ({
  logo,
  compact = false,
  ariaLabel,
  className,
  logoClassName,
}) => (
  <div
    className={cx("flex min-w-0 items-center leading-none gap-2", className)}
    role="img"
    aria-label={ariaLabel}
  >
    <span
      className={cx(
        "flex shrink-0 items-center justify-center [&_img]:block [&_img]:max-w-full [&_img]:object-contain",
        compact
          ? "h-5 w-[6.75rem] [&_img]:max-h-5"
          : "h-6 w-[8.25rem] [&_img]:max-h-6",
        logoClassName,
      )}
      aria-hidden="true"
    >
      {logo ?? (
        <span className="text-xs font-semibold tracking-[0.16em] text-zinc-100">
          NVIDIA
        </span>
      )}
    </span>
  </div>
);

BrandLockup.displayName = "BrandLockup";

export default BrandLockup;
